import React from "react";
import Nav from "./Components/Nav";
import Footer from "./Components/Footer";
import CHFrBodyLocations from "./Components/BodyFrLocations";

class CHFrLocations extends React.Component {
  render() {
    return (
      <>
        <Nav />
        <CHFrBodyLocations />
        <Footer />
      </>
    );
  }
}

export default CHFrLocations;
